<div class="render-report-container">
  <!-- Loading Indicator -->
  @if (isLoading) {
    <div class="loader-container">
      <kendo-loader type="infinite" themeColor="primary" size="large"></kendo-loader>
      <div class="loading-text">Loading report viewer...</div>
    </div>
  }

  <!-- Native Report Viewer -->
  @if (reportId && !isLoading && !hasError) {
    <report-viewer
      [reportId]="reportId"
      [transactionId]="transactionId"
      [siteId]="siteId"
      [windowMode]="false">
    </report-viewer>
  }

  <!-- IFrame Viewer (Fallback) -->
  @if (pdfUrl && !reportId) {
    <div [hidden]="isLoading || hasError" class="iframe-container">
      <iframe [src]="pdfUrl" width="100%" height="100%" frameborder="0" (load)="onIframeLoad()"></iframe>
    </div>
  }

  <!-- Error Card -->
  @if (hasError) {
    <div class="error-container">
      <div class="error-card">
        <span class="k-icon k-i-warning warning-icon"></span>
        <h3>Error Loading Report</h3>
        <p>{{ errorMessage }}</p>
      </div>
    </div>
  }
</div>